/*
 * Sidebar.jsx 02.08.18
 *
 * (c) 2018 ergovia GmbH
 */

import React from 'react';
import { withRouter } from 'react-router';
import {withStyles} from '@material-ui/core/styles';
import PeopleIcon from '@material-ui/icons/People';
import NavigateNext from '@material-ui/icons/NavigateNext';


const styles = theme => ({

    sidebar: {
        gridArea: 'sidebar',
        borderTopLeftRadius: theme.shape.borderRadius,
        borderBottomLeftRadius: theme.shape.borderRadius,

        color: theme.palette.text.primary,
        background: 'linear-gradient(135deg, #4B4B5D 0%, #3F3F4E 100%)',

        cursor: 'pointer'
    }
});

class Sidebar extends React.Component {

    handleClick() {
        const location = {
            pathname: '/'
        };

        this.props.history.push(location);
    }

    render() {
        const {classes} = this.props;

        return (
            <div className={classes.sidebar} onClick={this.handleClick.bind(this)}>
                <PeopleIcon style={{position: 'relative', left: '10px', top: '10px'}} />
                <NavigateNext style={{position: 'relative', left: '5px', top: '10px'}} />
            </div>
        );
    }
}

export default withRouter(withStyles(styles)(Sidebar));



// WEBPACK FOOTER //
// ./src/de/ergovia/components/detail/Sidebar.jsx